import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Braces } from 'lucide-react'

import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet'
import { Button } from '@/components/ui/button'
import { VariableReference } from './VariableReference'
import type { AdCodeVariableGroup } from '../lib/adCodeVariables'

interface VariableReferenceSheetProps {
  groups: AdCodeVariableGroup[]
  /** Overrides the default "Placeholders" button label. */
  label?: string
}

/**
 * The placeholder reference, off the right edge rather than as a card. The
 * editor already completes these as you type, so the full list is a lookup you
 * reach for occasionally — not something worth a screenful of the form.
 */
export function VariableReferenceSheet({ groups, label }: VariableReferenceSheetProps) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button type="button" variant="outline" size="sm" onClick={() => setOpen(true)}>
        <Braces className="size-3.5" />
        {label ?? t('creatives.placeholders')}
      </Button>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent className="w-full sm:max-w-xl overflow-y-auto">
          <SheetHeader>
            <SheetTitle>{t('creatives.variableReference')}</SheetTitle>
            <SheetDescription>{t('creatives.placeholdersHint')}</SheetDescription>
          </SheetHeader>
          <VariableReference groups={groups} />
        </SheetContent>
      </Sheet>
    </>
  )
}
